<template>
    <div class="main-container">
        <!-- Navbar section -->
        <Navbar />

        <!-- hero section -->
        <Hero />

        <!-- tab one components start -->
        <div class="tabs-wrapper section-space--ptb_90" id="about">
            <div class="container">
                <TabOne />
            </div>
        </div>

        <!-- footer section -->
        <FooterMain />

    </div>
</template>

<script>
    import Hero from '../comp_trustami/Tokenizer/Hero'
    import TabOne from '../comp_trustami/Tokenizer/TabOne'
    import FooterMain from '../comp_trustami/FooterMain'
    import Navbar from "../comp_trustami/NavbarSub";

    export default {
        name: 'app',
        components: {
            Navbar,
            Hero,
            TabOne,
            FooterMain,
        },

        metaInfo: {
            title: 'Sentence-Tokenization - Trustami.AI Web Services',
            meta: [
                {
                    name: 'description',
                    content: 'Get your text in order.'
                }
            ],
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        }
    }
</script>
